import { forwardRef } from 'react'

import { type Except } from 'type-fest'

import { type ZodFormProviderProps, ZodFormSubmitProvider } from '@/components/atoms/Form/ZodFormSubmitProvider'

import { RegionsMilestonesFormZod } from './RegionsMilestonesFormZod'

export type RegionsMilestonesFormProviderProps = Except<ZodFormProviderProps<typeof RegionsMilestonesFormZod>, 'schema'>

export const RegionsMilestonesFormProvider = forwardRef<HTMLFormElement, RegionsMilestonesFormProviderProps>(
  ({ children, ...props }, ref) => (
    <ZodFormSubmitProvider schema={RegionsMilestonesFormZod} ref={ref} {...props}>
      {children}
    </ZodFormSubmitProvider>
  )
)
